// 📁 src/components/LoginRegisterRole.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../api';
import socket from '../socket';

export default function LoginRegisterRole({ setAuthenticated }) {
  const [isLogin, setIsLogin] = useState(true);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('player');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const endpoint = isLogin ? '/api/login' : '/api/register';
      const res = await axios.post(endpoint, { username, password }, { withCredentials: true });

      // Assign role during registration
      if (!isLogin && role) {
        await axios.post('/api/set-role', { role }, { withCredentials: true });
      }

      setAuthenticated(true);

      // Load current session
      const session = await axios.get('/api/me', { withCredentials: true });
      const user = session.data.user;

      // 🔥 FORCE SOCKET RECONNECT AFTER LOGIN
      socket.connect();

      // 🔥 IDENTIFY USER TO SERVER FOR ONLINE TRACKING
      socket.on("connect", () => {
        console.log("🔵 Socket connected after login. Identifying user:", user._id);
        socket.emit("identify", user._id);
      });

      // Redirect based on role
      if (!user.role) {
        navigate('/select-role');
      } else if (user.role === 'admin') {
        navigate('/admin');
      } else {
        navigate('/lobby');
      }

    } catch (err) {
      const msg = err.response?.data?.error || 'Something went wrong';
      alert(msg);
    }
  };

  return (
    <div className="p-6 max-w-md mx-auto">
      <h2 className="text-2xl font-bold mb-4">
        {isLogin ? 'Login' : 'Register & Choose Role'}
      </h2>

      <form onSubmit={handleSubmit} className="space-y-4">

        <input
          className="border p-2 w-full"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />

        <input
          className="border p-2 w-full"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        {!isLogin && (
          <select
            className="border p-2 w-full"
            value={role}
            onChange={(e) => setRole(e.target.value)}
          >
            <option value="player">Player</option>
            <option value="admin">Admin</option>
          </select>
        )}

        <button className="bg-blue-600 text-white px-4 py-2 rounded" type="submit">
          {isLogin ? 'Login' : 'Register'}
        </button>

        <p
          className="text-sm mt-2 cursor-pointer underline"
          onClick={() => setIsLogin(!isLogin)}
        >
          {isLogin
            ? "Don't have an account? Register"
            : 'Have an account? Login'}
        </p>
      </form>
    </div>
  );
}
